import { render } from "./country-detail.vue?vue&type=template&id=0e1c202d"
import script from "./country-detail.vue?vue&type=script&lang=js"
export * from "./country-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__